
<div class="card">
  <div class="card-header d-flex align-items-center justify-content-between">
    <div class=" p-2">
      <span class="box-title mr-2">Oficina: </span>
      <span class="box-subtitle">{{informacion?.oficina}}</span>
    </div>

    <div class=" p-2">
      <span class="box-title">Oficial: </span>
      <span class="box-subtitle mr-2">{{ informacion?.oficial }}</span>
    </div>
  </div>


  <ul class="list-group list-group-flush">
    <li class="list-group-item d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        Saldo Actual
        <span class="material-icons ml-2">
          chevron_right
        </span>
      </div>
      <span class="box-subtitle">{{informacion?.saldoActual | currency}}</span>
    </li>
    <li class="list-group-item d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        Último Pago
        <span class="material-icons ml-2">
          chevron_right
        </span>
      </div>
      <span *ngIf="informacion?.ultimoPago != '01/01/0001'" class="box-subtitle">{{informacion?.ultimoPago}}</span>
    </li>
    <li class="list-group-item d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        Próximo Vencimiento
        <span class="material-icons ml-2">
          chevron_right
        </span>
      </div>
      <span>{{ informacion?.proximoVencimiento }}</span>
    </li>
    <li class="list-group-item d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        Valor a Cancelar
        <span class="material-icons ml-2">
          chevron_right
        </span>
      </div>
      <span class="box-subtitle">{{ informacion?.valorCancelar | currency}}</span>
    </li>
    <li class="list-group-item d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        Cuotas Vencidas
        <span class="material-icons ml-2">
          chevron_right
        </span>
      </div>
      <span class="box-subtitle">{{ informacion?.numeroCuotasVencidas }}</span>
    </li>
    <li class="list-group-item d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        Cuotas Canceladas
        <span class="material-icons ml-2">
          chevron_right
        </span>
      </div>
      <span class="box-subtitle">{{ informacion?.cuotasCanceladas + ' / ' + totalCuotas }}</span>
    </li>
  </ul>
</div>





